import React from 'react';

type Props = {
  children: React.ReactNode;
  heading: string;
  action?: React.ReactNode;
  bgColor?: string;
};
const BusinessBoard = ({ children, heading, action, bgColor = 'bg-white' }: Props) => {
  return (
    <>
      <div className={`block mx-auto w-full ${bgColor} px-5 pb-5 rounded-lg shadow mb-8 max-w-7xl`}>
        <div className='flex justify-between bg-white items-center px-5 py-5'>
          <h2 className='text-blue-lm text-2xl'>{heading}</h2>
          {action && <div>{action}</div>}
        </div>
        {children}
      </div>
    </>
  );
};

export default BusinessBoard;
